import React from "react";
import InternalLayout from "../../../../../layouts/internalLayout";
import Left from "./left";
import { useState } from 'react'
import { useMessage } from '../../../../../context/messageContext'
import { useEffect } from "react";
import { productHardwareStyleMenu } from "../../../../../utility/data";
import { Oval } from "react-loader-spinner";
import { useLocation } from "react-router-dom";
import { useRightContext } from "../../../../../context/rightMenuContext";
import { MdKeyboardArrowDown } from "react-icons/md";
import { Dropdown, DropdownToggle, DropdownItem, DropdownMenu } from "reactstrap";
import CustomizedButton from "../../../../../components/CustomizedButton";
import NoDataCard from "../../../../../components/NoDataCard";

const PricingHardwareBarHandleInline = () => {
  var access_token = localStorage.getItem("access_token")

  const { setMessage, setMessageType } = useMessage()
  const { setMainMenuActive, setSubMenuActive, setSubMenu2Active, userDataContext } = useRightContext()

  const [loading, setLoading] = useState(false)

  const location = useLocation();
  
  const collectionId = location.state ? location.state.data : null

  console.log(location, "location")

  const [headerDropdown, setHeaderDropdown] = useState(false);
  const [mainDropdownList, setMainDropdownList] = useState([])
  const [frameCollection, setFrameCollection] = useState('')

  useEffect(() => {
    setMainDropdownList(productHardwareStyleMenu)

    setMainMenuActive("Pricing")
    setSubMenuActive("Hardware")
    setSubMenu2Active("")
  }, []);

  useEffect(() => {
    if (mainDropdownList && mainDropdownList.length > 0) {
      if (collectionId) {
        const collectionItem = mainDropdownList?.find((p) => p.id == collectionId)

        if (collectionItem && collectionItem.id) {
          setFrameCollection(collectionItem)
        }
      } else {
        setFrameCollection(mainDropdownList[0])
      }
    }
  }, [mainDropdownList]);

  const toggleTabDropdown = () => setHeaderDropdown((prevState) => !prevState);

  const handleItemSelect = (value) => {
    setFrameCollection(value)
  }

  const data1 = { url: `/product/hardware/list`, stateValue: frameCollection?.id }

  return (
    <>
      {loading && (
        <div className="loader_main full_loader">
          <Oval
            height={50}
            width={50}
            color="#44C8F5"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#44C8F5"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      )}

      {/* <InternalLayout
        pageTitle="Hardware"
        layoutType="full"
        leftContent={<Left token={access_token} styleId={styleId} pageName={pageName} setMessage={setMessage} setMessageType={setMessageType} loading={loading} setLoading={setLoading} />}
        rightContent={""}
      /> */}

      {mainDropdownList && mainDropdownList.length > 0 ? (
        <InternalLayout
          pageTitle=""
          layoutType="full"
          leftContent={
            <Left token={access_token} 
            styleId={frameCollection.id} 
            pageName={''} 
            setMessage={setMessage} 
            setMessageType={setMessageType} 
            loading={loading} 
            setLoading={setLoading} 
            userDataContext={userDataContext}
          />
          }
          rightContent={""}
          filterButton={
            <>
              <Dropdown
                isOpen={headerDropdown}
                toggle={toggleTabDropdown}
              >
                <DropdownToggle color="none" className="border-0 p-0">
                  <div className="d-flex align-items-center">
                    <span className="fw-semibold fs-5">
                      {frameCollection && frameCollection?.title}
                      <MdKeyboardArrowDown className="ms-1" size={20} />
                    </span>
                  </div>
                </DropdownToggle>

                <DropdownMenu className='full_height'>
                  {mainDropdownList?.map((item, index) => {
                    return (
                      <DropdownItem
                        onClick={() => handleItemSelect(item)}
                        key={index}
                        disabled={item?.id == frameCollection?.id}
                        className={`${item?.id == frameCollection?.id ? 'text-primary fw-medium' : ''}`}
                      >
                        {item?.title}
                      </DropdownItem>
                    );
                  })}
                </DropdownMenu>
              </Dropdown>
              <CustomizedButton data={data1} hasState={true} />
            </>
          }
        />
      ) : (
        <NoDataCard text="hardware" loading={loading} />
      )}

    </>
  );
};

export default PricingHardwareBarHandleInline;
